'use client';

import { useEffect, useRef } from 'react';

/** Animate changed content without remounting controls or moving keyboard focus. */
export default function usePanelTransition<T extends HTMLElement = HTMLDivElement>(
  selection: string | number,
) {
  const panelRef = useRef<T>(null);
  const previousSelection = useRef(selection);

  useEffect(() => {
    if (previousSelection.current === selection) return;
    previousSelection.current = selection;

    const panel = panelRef.current;
    if (
      !panel?.animate ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) return;

    const animation = panel.animate(
      [
        { opacity: 0.65, transform: 'translateY(8px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      { duration: 200, easing: 'cubic-bezier(.2,.7,.2,1)' },
    );

    return () => animation.cancel();
  }, [selection]);

  return panelRef;
}
